import { render } from "./App.vue?vue&type=template&id=236738d4&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=236738d4&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=236738d4&lang=scss"

import exportComponent from "/opt/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236738d4"]])

export default __exports__